export default __webpack_public_path__ + "static/fZAAVzSY-d90b7178d9d3e49e8c58a4ac8d11fdae.svg";